/** Utility functions and objects for use in browser
 * 
 */


/** Download CSV data from web client to user
 * 
 * With thanks to https://www.raymondcamden.com/2020/12/15/vue-quick-shot-downloading-data-as-a-file
 */
export function download_csv(csv, filename){
   // Prepare dummy link anchor with the download
   let a = document.createElement('a')
   a.setAttribute('href', 
      'data:text/csv;charset=utf-8,' 
      + encodeURIComponent(csv))
   a.setAttribute('download', filename)
   // Enable it invisibly and activate download
   a.style.display = 'none'
   document.body.appendChild(a)
   a.click()
   // Clean up
   document.body.removeChild(a)
}

/** Download remote protected file to user
 * 
 * Based on answers to https://stackoverflow.com/questions/3749231/download-file-using-javascript-jquery
*/
export function download_blob(blob, filename){
     const internalUrl = window.URL.createObjectURL(blob)
     // Prepare dummy link anchor with the download
     const a = document.createElement('a')
     a.setAttribute('href', internalUrl)
     a.setAttribute('download', filename)
     a.setAttribute('target', '_blank')
     a.target="_blank"
     // Enable it invisibly and activate download
     a.style.display = 'none'
     document.body.appendChild(a);
     a.click();
     // Clean up
     window.URL.revokeObjectURL(internalUrl)
     document.body.removeChild(a)
}